export const licenseExpireAtMs = {
  type: "number",
  minimum: 1,
  maximum: Number.MAX_SAFE_INTEGER
};
